import {Directive, ElementRef} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {scrollTilBunn} from "web-ng2/delt/dom/scrollIntoView";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

const debug = initDebugger('NavigasjonforhindretFlashDirektiv');

/**
 * Blinker elementet attributtet er deklarert på når navigasjon har blitt forhindret.
 * Se {@link NavigasjonDeaktivering#navigasjonForhindret}
 */
@Directive({
    selector: '[navigasjonforhindret-flash]',
    standalone: true
})
export class NavigasjonforhindretFlashDirektiv {
    private static cssKlass = 'navigasjonforhindret-blink';

    private pågåendeFlash: number | null = null;

    constructor(private el: ElementRef<HTMLElement>, navigasjonDeaktivering: NavigasjonDeaktivering) {
        debug('konstruktør')
        navigasjonDeaktivering.navigasjonForhindret
          .pipe(takeUntilDestroyed())
          .subscribe(() => this.navigasjonForhindret());
    }

    private navigasjonForhindret() {
        debug('navigasjonForhindret')
        if (erIkkeNil(this.pågåendeFlash)) return;

        this.scrollTil();
        this.el.nativeElement.classList.add(NavigasjonforhindretFlashDirektiv.cssKlass);
        this.pågåendeFlash = window.setTimeout(() => this.flash(), 1000);
    }

    private scrollTil() {
        scrollTilBunn(this.el.nativeElement);
    }

    private flash() {
        this.el.nativeElement.classList.remove(NavigasjonforhindretFlashDirektiv.cssKlass)
        this.pågåendeFlash = null;
    }

}
